export const REFINEMENT_SMALL_PACKAGE_PRICE = 149;
export const REFINEMENT_LARGE_PACKAGE_PRICE = 199;
